// Generated by build-browser-modules.cjs from tested contract-source.

// Candidate display/selection contract only. Never calculates a cash price,
// credits a wallet, grants rolls, reserves stock or authorizes an order.
import {checkedCapability} from "../opnopoly-client.js";
import {OPNOPOLY_UI_RELEASE_READY} from "../opnopoly-release.js";
const SCHEMA = 'opgames-monopoly-catalog-v2';
const DETAIL_SCHEMA = 'opgames-monopoly-package-v2';
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const CURRENCIES = Object.freeze(['CNY','HKD']);
const PAYMENT_METHODS = Object.freeze(['alipay','wechat','visa']);
const CATALOG_ROUTE = '/v1/monopoly/packages?currency=CNY';
const PURCHASE_PAGE = '/credit-packages/?currency=CNY&activity=opnopoly';
const DEFINITIONS = Object.freeze([
    ['e5955e2e-4e73-49bc-815b-f12ca402e5ed','daily_limited',1,433,288,3],
    ['fe280572-e20d-4302-8134-23bd52db328a','daily_limited',2,972,648,7],
    ['8cc3fc91-a76a-4843-a41d-c918741496ea','daily_limited',3,1971,1314,15],
    ['9cbb975a-bab4-47ea-9380-aa7872ac6de8','daily_limited',4,5625,3750,45],
    ['42915858-d86b-4830-82d4-6bd629815958','normal',1,740,494,1],
    ['36c2619f-fb08-44e7-a226-99115cf5b79a','normal',2,1400,934,3],
    ['0ad24f56-44e9-4a73-8452-fe0a30bf9d2e','normal',3,2779,1854,9],
    ['8329e707-696e-4759-a5a2-08a619c750eb','normal',4,5412,3608,23],
    ['4336e000-9a7c-4f29-af6e-c9303acc0fdd','normal',5,9015,6010,46],
    ['b8ba718e-6bca-4d83-8f20-35b1f22a00a8','normal',6,13806,9204,78]
].map(([productId,group,tier,paidGold,freeGold,rolls]) => Object.freeze({productId,group,tier,paidGold,freeGold,rolls})));
const BY_ID = new Map(DEFINITIONS.map(row => [row.productId,row]));
const integer = n => Number.isSafeInteger(n) && n >= 0;
const object = v => !!v && typeof v === 'object' && !Array.isArray(v);
const exact = (v,keys) => object(v) && Object.keys(v).sort().join(',') === keys.slice().sort().join(',');
const fail = code => Object.assign(new Error(code),{code});
const copy = v => JSON.parse(JSON.stringify(v));
const commonFields = ['schema','enabled','issuedAt','expiresAt','userId','gameId','activityId','policyVersion','currency'];
const rowFields = ['productId','group','tier','paidGold','freeGold','rolls','priceMinor','available','dailyRemaining','availability','paymentMethods'];

function checkedCurrency(currency) { if (!CURRENCIES.includes(currency)) throw fail('INVALID_CURRENCY'); return currency; }
function catalogRoute(currency='CNY') { return '/v1/monopoly/packages?currency=' + checkedCurrency(currency); }
function purchasePage(currency='CNY') { return '/credit-packages/?currency=' + checkedCurrency(currency) + '&activity=opnopoly'; }
function isOpnopolyProduct(productId) { return BY_ID.has(productId); }
function hasOpnopolyMarker(search) {
    return typeof search === 'string' && new URLSearchParams(search).getAll('activity').includes('opnopoly');
}
function validPurchaseSearch(search) {
    const q = new URLSearchParams(search || '');
    return q.getAll('activity').length === 1 && q.get('activity') === 'opnopoly'
        && q.getAll('currency').length === 1 && CURRENCIES.includes(q.get('currency'))
        && [...q.keys()].every(key => key === 'activity' || key === 'currency');
}
function detailRoute(productId,currency='CNY') {
    if (!isOpnopolyProduct(productId)) throw fail('INVALID_PRODUCT');
    return '/v1/monopoly/package?productId=' + productId + '&currency=' + checkedCurrency(currency);
}
function checkedScope(value,capability,identity,now,schema,contentKey,currency) {
    checkedCurrency(currency);
    const cap = checkedCapability(capability,identity,now);
    if (!cap.packageCatalogReady || !exact(value,[...commonFields,contentKey]) || value.schema !== schema
        || value.enabled !== true || value.userId !== cap.userId || value.gameId !== cap.gameId
        || value.activityId !== cap.activityId || value.policyVersion !== cap.packagePolicyVersion
        || value.currency !== currency || !integer(value.issuedAt) || !integer(value.expiresAt)
        || value.issuedAt > now + 5000 || value.expiresAt <= now || value.expiresAt <= value.issuedAt
        || value.expiresAt - value.issuedAt > 60000
        || value.expiresAt > cap.weekEndsAt) throw fail('CATALOG_UNAVAILABLE');
    return cap;
}
function checkedRow(value) {
    const binding = object(value) && BY_ID.get(value.productId);
    if (!binding || !(exact(value,rowFields)||exact(value,[...rowFields,'pendingPayment'])) || Object.keys(binding).some(key => value[key] !== binding[key])
        || !integer(value.priceMinor) || value.priceMinor < 1 || typeof value.available !== 'boolean'
        || !Array.isArray(value.paymentMethods) || value.paymentMethods.some(method => !PAYMENT_METHODS.includes(method))
        || new Set(value.paymentMethods).size !== value.paymentMethods.length || (value.available && value.paymentMethods.length === 0)
        || !['AVAILABLE','DAILY_LIMIT_REACHED','UNAVAILABLE'].includes(value.availability)
        || value.available !== (value.availability === 'AVAILABLE')
        || (binding.group === 'daily_limited' ? ![0,1].includes(value.dailyRemaining) : value.dailyRemaining !== null)
        || (value.available && value.dailyRemaining === 0)
        || (value.availability === 'DAILY_LIMIT_REACHED' && (binding.group !== 'daily_limited' || value.dailyRemaining !== 0))) {
        throw fail('INVALID_CATALOG_ROW');
    }
    const pending=value.pendingPayment||null;
    if(pending&&(!exact(pending,['orderId','providerId','requestId'])||!UUID.test(pending.orderId||'')
        ||!['antpay','antpay3','apluspay'].includes(pending.providerId)||binding.group!=='daily_limited'
        ||(pending.providerId==='apluspay'?!UUID.test(pending.requestId||''):pending.requestId!==null)))throw fail('INVALID_PENDING_PAYMENT');
    // Exact public projection: arbitrary server fields never reach a provider.
    return {...binding,priceMinor:value.priceMinor,available:value.available,dailyRemaining:value.dailyRemaining,availability:value.availability,paymentMethods:value.paymentMethods.slice(),pendingPayment:pending?{...pending}:null};
}
function checkedCatalog(value,capability,identity,now,currency='CNY') {
    const cap = checkedScope(value,capability,identity,now,SCHEMA,'rows',currency);
    if (!Array.isArray(value.rows) || value.rows.length !== DEFINITIONS.length) throw fail('INVALID_CATALOG');
    const rows = value.rows.map(checkedRow);
    if (new Set(rows.map(row => row.productId)).size !== DEFINITIONS.length) throw fail('INVALID_CATALOG');
    // Readiness and catalogue are issued by separate authenticated requests.
    // Keep the shorter lifetime; a later quote must never extend readiness.
    return {...value,expiresAt:Math.min(value.expiresAt,cap.expiresAt),rows:DEFINITIONS.map(binding => rows.find(row => row.productId === binding.productId))};
}
function checkedDetail(value,capability,identity,now,productId,currency='CNY') {
    const cap = checkedScope(value,capability,identity,now,DETAIL_SCHEMA,'row',currency);
    const row = checkedRow(value.row);
    if (row.productId !== productId) throw fail('INVALID_PRODUCT');
    return {...value,expiresAt:Math.min(value.expiresAt,cap.expiresAt),row};
}
function checkedSelection(detail,catalog,capability,identity,now,productId,currency='CNY') {
    const current = checkedCatalog(catalog,capability,identity,now,currency);
    const fresh = checkedDetail(detail,capability,identity,now,productId,currency);
    const listed = current.rows.find(row => row.productId === productId);
    if (!listed || !listed.available || !fresh.row.available) throw fail('PACKAGE_UNAVAILABLE');
    if (listed.priceMinor !== fresh.row.priceMinor) throw fail('PRICE_CHANGED');
    return {path:'/payment-providers/?productId=' + productId + '&currency=' + currency + '&activity=opnopoly',
        state:{paymentQuote:{productId,currency,price:fresh.row.priceMinor / 100,paymentMethods:fresh.row.paymentMethods.slice()}}};
}

// A single navigation may reuse its freshly validated offer for display only.
// Never persist this receipt or use it to authorize order creation.
let selectionHandoff=null;
function takeSelectionHandoff(identity,capability,productId,currency,now=Date.now()) {
    const receipt=selectionHandoff;selectionHandoff=null;
    if(!receipt||!identity||!capability||!identity.accessToken||receipt.accessToken!==identity.accessToken
        ||receipt.userId!==identity.userId||receipt.gameId!==identity.gameId
        ||receipt.weekId!==capability.weekId||receipt.productId!==productId||receipt.currency!==currency
        ||now<receipt.receivedAt||now-receipt.receivedAt>5000)return null;
    try{return copy(checkedDetail(receipt.detail,capability,identity,now,productId,currency));}
    catch(_){return null;}
}

class OpnopolyCatalogClient {
    constructor(api,{clock=()=>Date.now(),releaseReady=OPNOPOLY_UI_RELEASE_READY,currency='CNY'}={}) {
        if (!api || typeof api.call !== 'function' || typeof api.session !== 'function'
            || !UUID.test((api.identity && api.identity.userId) || '') || !UUID.test((api.identity && api.identity.gameId) || '')) throw fail('UNAUTHORIZED');
        this.api = api; this.identity = {userId:api.identity.userId,gameId:api.identity.gameId};
        this.currency = checkedCurrency(currency);
        this.clock = clock; this.releaseReady = releaseReady; this.catalog = null; this.capability = null;
        this.disposed = false; this.generation = 0; this.pending = null; this.selecting = false;
    }
    dispose() { this.disposed = true; this.generation++; this.catalog = null; this.capability = null; }
    guard(generation) {
        if (this.disposed || generation !== this.generation || this.api.identity.userId !== this.identity.userId
            || this.api.identity.gameId !== this.identity.gameId) throw fail('CATALOG_UNAVAILABLE');
    }
    async loadCapability(generation) {
        if (this.releaseReady !== true) throw fail('CATALOG_UNAVAILABLE');
        this.guard(generation);
        let session = await this.api.session();
        this.guard(generation);
        // Allow enough time for the subsequent catalogue/detail request.
        if (session.monopoly && session.monopoly.expiresAt <= this.clock() + 30000) {
            session = await this.api.session(true);
        }
        this.guard(generation);
        const cap = checkedCapability(session.monopoly,this.identity,this.clock());
        if (cap.packageCatalogReady !== true || !integer(session.expiresAt) || cap.expiresAt > session.expiresAt) throw fail('CATALOG_UNAVAILABLE');
        this.capability = cap; return cap;
    }
    async refresh() {
        if (this.pending) return this.pending;
        const generation = this.generation;
        this.pending = (async () => {
            try {
                const cap = await this.loadCapability(generation);
                const response = await this.api.call(catalogRoute(this.currency));
                this.guard(generation);
                this.catalog = checkedCatalog(response,cap,this.identity,this.clock(),this.currency);
                return copy(this.catalog);
            } catch (error) { this.catalog = null; throw error; }
            finally { this.pending = null; }
        })();
        return this.pending;
    }
    async select(productId) {
        if (this.selecting) throw fail('SELECTION_PENDING');
        selectionHandoff=null;
        const generation = this.generation;
        this.selecting = true;
        try {
            const cap = await this.loadCapability(generation);
            const catalog = checkedCatalog(this.catalog,cap,this.identity,this.clock(),this.currency);
            const row = catalog.rows.find(item => item.productId === productId);
            if (!row || !row.available) throw fail('PACKAGE_UNAVAILABLE');
            const detail = await this.api.call(detailRoute(productId,this.currency));
            this.guard(generation);
            const now=this.clock(),selection=checkedSelection(detail,catalog,cap,this.identity,now,productId,this.currency);
            selectionHandoff={accessToken:this.api.identity.accessToken,userId:this.identity.userId,gameId:this.identity.gameId,
                weekId:cap.weekId,productId,currency:this.currency,receivedAt:now,
                detail:copy(checkedDetail(detail,cap,this.identity,now,productId,this.currency))};
            return selection;
        } catch (error) { this.catalog = null; throw error; }
        finally { this.selecting = false; }
    }
}
export {SCHEMA,DETAIL_SCHEMA,DEFINITIONS,CURRENCIES,PAYMENT_METHODS,CATALOG_ROUTE,PURCHASE_PAGE,catalogRoute,purchasePage,detailRoute,isOpnopolyProduct,
    hasOpnopolyMarker,validPurchaseSearch,checkedCatalog,checkedDetail,checkedSelection,takeSelectionHandoff,OpnopolyCatalogClient};
